import { CSSObject } from '@emotion/react';
import { useTheme } from '@cvent/carina/components/ThemeProvider';
import { useBreakpoints } from '@cvent/carina/components/Breakpoints';
import { useCustomBreakpoints } from '@hooks/display/useCustomBreakpoints';

export const useFooterStyle = (): Record<string, CSSObject> => {
  const { font, spacing } = useTheme();
  const breakpoints = useBreakpoints();
  const { isMobile } = useCustomBreakpoints(breakpoints);

  return {
    leftColPadding: {
      top: 16,
      start: isMobile ? 0 : 8,
      end: 0
    },
    rightColPadding: {
      top: 16,
      bottom: isMobile ? 16 : 0,
      start: 0,
      end: isMobile ? 0 : 8
    },
    bottomColPadding: {
      top: 16,
      bottom: isMobile ? 16 : 0,
      start: 0,
      end: isMobile ? 0 : 8
    },
    leftColFlex: {
      display: 'flex',
      justifyContent: isMobile ? 'center' : 'flex-end'
    },
    rightColFlex: {
      display: 'flex',
      justifyContent: isMobile ? 'center' : 'flex-start'
    },
    bottomColFlex: {
      display: 'flex',
      justifyContent: isMobile ? 'center' : 'flex-end'
    },
    footerLink: {
      fontFamily: font.base.family,
      color: font.color.soft,
      fontSize: font.base.size['2'],
      paddingLeft: spacing['3'],
      paddingRight: spacing['3'],
      textDecoration: 'none'
    },
    footerButton: {
      fontFamily: font.base.family,
      color: font.color.soft,
      fontSize: font.base.size['2'],
      paddingLeft: spacing['3'],
      paddingRight: spacing['3'],
      textDecoration: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center'
    },
    copyright: {
      fontFamily: font.base.family,
      color: font.color.soft,
      fontSize: font.base.size['2'],
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'flex-end'
    }
  };
};
